import { motion, useInView } from "framer-motion";
import { useRef, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PortfolioSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    axios.get(`${API}/projects`).then(res => setProjects(res.data)).catch(() => {});
  }, []);

  return (
    <section id="portfolio" className="py-24 md:py-32 px-6 md:px-12 bg-[#0A0A0A]" data-testid="portfolio-section" ref={ref}>
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="mb-16"
        >
          <p className="font-sans text-xs uppercase tracking-[0.3em] text-[#E8891C] mb-4">Portfolio</p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#F5F5F0] tracking-tight" data-testid="portfolio-title">
            Realisations <span className="italic">signature</span>
          </h2>
        </motion.div>

        {/* Masonry grid */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 space-y-4">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, delay: index * 0.12, ease: "easeOut" }}
              className="group relative break-inside-avoid img-zoom"
              data-testid={`portfolio-item-${index}`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={project.images?.[0] || ""}
                  alt={project.title}
                  className="w-full object-cover"
                  loading="lazy"
                />
                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/60 transition-all duration-500 flex items-end">
                  <div className="p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                    <p className="font-sans text-xs uppercase tracking-[0.2em] text-[#E8891C] mb-2">{project.category}</p>
                    <h3 className="font-serif text-xl text-[#F5F5F0] mb-1">{project.title}</h3>
                    <p className="font-sans text-sm text-[#A1A1AA]">{project.description}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {projects.length === 0 && (
          <div className="text-center py-20">
            <p className="font-sans text-sm text-[#A1A1AA]">Chargement des projets...</p>
          </div>
        )}
      </div>
    </section>
  );
};
